import { AccessCard } from './access-card'
export class AccessCardExport {
  Company_Name: string;
  Holder_Name: string;
  Access_Card_Type: string;
  Badge_Number: string;
  Start_Date: Date;
  End_Date: Date;
  Status: string;

  constructor(accessCard: AccessCard) {
    this.Company_Name = accessCard.companyName;
    this.Holder_Name = accessCard.holderName;
    this.Access_Card_Type = accessCard.accessCardTypeName;
    this.Badge_Number = accessCard.badgeNumber;
    this.Start_Date = accessCard.startDate;
    this.End_Date = accessCard.endDate;
    this.Status = accessCard.statusName;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/access-card-export.ts